
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientionwarmingsystemmanufacture() {



  const cardData =
  {
    keyword: 'Patient Warming System Manufacturers in India',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming System Manufacturers in India',
    headingDescription: 'Pharmacle Health Care Private Limited is a leading manufacturer of high-quality Patient Warming Systems in India, dedicated to ensuring effective temperature management during surgeries and critical care. Our advanced warming systems are designed to prevent hypothermia by delivering consistent and controlled heat, thereby enhancing patient safety and recovery. Widely utilized in hospitals and healthcare facilities across the country, our patient warming systems are reliable, user-friendly, and incorporate cutting-edge technology. Choose Pharmacle Health Care for superior warming solutions in India to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Leading Patient Warming System Manufacturers in India for Advanced Medical Solutions",
    "description": "Pharmacle Health Care is a trusted manufacturer of patient warming systems in India, offering innovative solutions to maintain body temperature during surgeries and critical care treatments."
  },
  {
    "title": "Top Patient Warming System Manufacturers in India for Hospitals and Clinics",
    "description": "Our systems are manufactured with high-quality components and advanced technology to support ICU, surgical, and emergency settings. Pharmacle Health Care is committed to excellence in medical innovation."
  },
  {
    "title": "Certified Patient Warming System Manufacturers in India",
    "description": "Pharmacle Health Care provides certified and compliant patient warming systems that meet international healthcare standards. Widely used in hospitals and healthcare institutions across India."
  },
  {
    "title": "Reliable Manufacturers of Patient Warming Systems in India",
    "description": "We manufacture patient warming systems that offer consistent performance, ease of use, and safety. Ideal for hospitals, surgical centers, and specialty clinics across India."
  },
  {
    "title": "India’s Trusted Patient Warming System Manufacturing Company",
    "description": "With a focus on quality and performance, Pharmacle Health Care designs and manufactures reliable warming systems used in perioperative and post-operative care settings."
  },
  {
    "title": "Affordable and Durable Patient Warming System Manufacturers in India",
    "description": "Our systems are cost-effective and built to last, making them ideal for both private and public healthcare facilities. Pharmacle Health Care delivers value without compromising on quality."
  },
  {
    "title": "Manufacturers of Hospital-Grade Patient Warming Systems in India",
    "description": "Pharmacle Health Care manufactures warming systems tailored for hospital environments, ensuring safe thermal support for both pediatric and adult patients during treatment."
  },
  {
    "title": "Innovative Patient Warming System Manufacturers in India",
    "description": "We use modern technology and efficient design to develop warming systems that enhance patient safety, reduce hypothermia risk, and streamline clinical workflows."
  },
  {
    "title": "Top-Rated Patient Warming System Manufacturer in India",
    "description": "Recognized for quality and customer satisfaction, Pharmacle Health Care has become a leading manufacturer of medical warming equipment in India’s healthcare industry."
  },
  {
    "title": "Comprehensive Patient Warming Solutions by Indian Manufacturer",
    "description": "Pharmacle Health Care manufactures a complete range of warming systems including blankets, machines, and mattresses designed to meet diverse clinical needs."
  }
],


   "services": [
    {
      "name": "Patient Warming System Manufacturers in India",
      "description": "Pharmacle Health Care is among the trusted patient warming system manufacturers in India, providing advanced solutions to maintain normothermia during medical procedures and enhance patient safety and comfort."
    },
    {
      "name": "Medical Warming Equipment Suppliers India",
      "description": "As a leading supplier of medical warming equipment in India, Pharmacle Health Care offers a wide range of devices to support temperature regulation in surgical and recovery environments across healthcare facilities."
    },
    {
      "name": "Surgical Heating Device Manufacturers India",
      "description": "We manufacture high-performance surgical heating devices in India designed to prevent intraoperative hypothermia and ensure precise temperature management during operations."
    },
    {
      "name": "Indian Hospital Warming Systems",
      "description": "Pharmacle Health Care provides reliable hospital warming systems in India to help maintain optimal patient temperatures throughout preoperative, intraoperative, and postoperative care stages."
    },
    {
      "name": "Patient Temperature Management India",
      "description": "Our patient temperature management solutions in India are engineered to ensure effective thermal control across various medical procedures, enhancing safety and recovery for patients nationwide."
    },
    {
      "name": "Hospital Warming Solutions Providers India",
      "description": "Pharmacle Health Care is a trusted provider of hospital warming solutions in India, offering customized devices and systems for surgical suites, recovery units, and intensive care departments."
    }
  ],
  "tableData": [
    ["- Patient Warming System Manufacturers in India", "- Medical Warming Equipment Suppliers India"],
    ["- Surgical Heating Device Manufacturers India", "- Indian Hospital Warming Systems"],
    ["- Patient Temperature Management India", "- Hospital Warming Solutions Providers India"]
  ],

"whychoose": [
    {
        "WhyChooseheading": "Leading Patient Warming System Manufacturers in India",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited stands out as a top Patient Warming System manufacturer in India, offering cutting-edge technology and precision temperature control to healthcare providers nationwide."
    },
    {
        "WhyChooseheading": "Comprehensive Range of Warming Solutions",
        "WhyChoosedescription": "As premier manufacturers in India, we provide an extensive range of Patient Warming Systems, including devices, blankets, and control systems, tailored to meet diverse clinical needs across hospitals and clinics."
    },
    {
        "WhyChooseheading": "High-Quality Manufacturing Standards",
        "WhyChoosedescription": "Our Patient Warming Systems are manufactured in India under strict quality control protocols, ensuring durable, reliable, and high-performance equipment suitable for demanding medical environments."
    },
    {
        "WhyChooseheading": "Patient Safety and Comfort Focus",
        "WhyChoosedescription": "Committed to patient safety, our India-manufactured Patient Warming Systems deliver gentle, consistent warmth to prevent hypothermia and other temperature-related complications during medical procedures."
    },
    {
        "WhyChooseheading": "Customized Solutions for Indian Healthcare Providers",
        "WhyChoosedescription": "We work closely with healthcare providers across India to customize Patient Warming Systems that fit specific clinical requirements, enhancing patient care and operational efficiency."
    },
    {
        "WhyChooseheading": "Seamless Integration with Existing Medical Systems",
        "WhyChoosedescription": "Our Patient Warming Systems, manufactured in India, are designed for easy integration with existing hospital equipment, ensuring minimal disruption and efficient workflow in healthcare settings."
    },
    {
        "WhyChooseheading": "Expert Support and Consultation Across India",
        "WhyChoosedescription": "Pharmacle Health Care offers expert consultation and comprehensive support nationwide, assisting Indian healthcare facilities in selecting, installing, and maintaining Patient Warming Systems."
    },
    {
        "WhyChooseheading": "Pioneering Commitment to Quality and Care",
        "WhyChoosedescription": "As leading Patient Warming System manufacturers in India, we prioritize patient safety and comfort, consistently delivering high-quality products that uphold the highest standards of medical care."
    }
]


























  }

const faqData = [
  {
    question: "Who are the leading Patient Warming System manufacturers in India?",
    answer: "Pharmacle Health Care Private Limited is one of the trusted manufacturers and suppliers of Patient Warming Systems in India. The company delivers high-quality thermal care solutions to hospitals and clinics across the country."
  },
  {
    question: "What makes Pharmacle Health Care a reliable manufacturer of Patient Warming Systems?",
    answer: "Pharmacle Health Care focuses on advanced technology, strict quality control, and customer-centric support. Our systems are designed for precision, safety, and ease of use, making them a preferred choice among Indian healthcare providers."
  },
  {
    question: "Where in India does Pharmacle Health Care supply Patient Warming Systems?",
    answer: "Pharmacle Health Care supplies Patient Warming Systems across India, including major cities like Kolkata, Delhi, Mumbai, Chennai, Bengaluru, and more. We cater to hospitals, surgical centers, and healthcare institutions nationwide."
  },
  {
    question: "Are the Patient Warming Systems from Pharmacle Health Care certified?",
    answer: "Yes, all our systems are manufactured in compliance with medical device standards and undergo rigorous testing to ensure performance, safety, and durability."
  },
  {
    question: "Does Pharmacle Health Care offer support for its Patient Warming Systems?",
    answer: "Absolutely. We provide complete after-sales support, including installation, product training, technical assistance, and regular maintenance to ensure optimal device performance."
  },
  {
    question: "How can I get in touch with Pharmacle Health Care to order Patient Warming Systems?",
    answer: "You can contact Pharmacle Health Care Private Limited through our website or customer service number. Our team will guide you through product selection and coordinate delivery anywhere in India."
  }
];

const testimonialsData = [
  {
    text: "Pharmacle Health Care stands out among Patient Warming System manufacturers in India. Their products are reliable, easy to use, and backed by excellent support services.",
    name: "Dr. Ramesh Verma, Delhi"
  },
  {
    text: "As a multispecialty hospital, we rely on Pharmacle Health Care’s Patient Warming Systems for surgeries across departments. Their commitment to quality and service makes them one of the top manufacturers in India.",
    name: "Medilife Hospital, Mumbai"
  }
];





  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



 
  const jsonData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Patient Warming System Manufacturers in India",
  "description": "Leading Patient Warming System Manufacturers in India providing advanced medical warming equipment and surgical heating devices. Trusted suppliers of hospital warming solutions for effective patient temperature management.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5154"
  }
};



  

  return (
    <div>
  

<Helmet>
  <title>Patient Warming System Manufacturers in India | Contact: +91 8956322311</title>
  <meta
    name="description"
    content="Leading Patient Warming System Manufacturers and medical warming equipment suppliers in India. Contact us at +91 8956322311."
  />
  <meta
    name="keywords"
    content="Patient Warming System Manufacturers in India, Medical Warming Equipment Suppliers India, Surgical Heating Device Manufacturers India, Indian Hospital Warming Systems, Patient Temperature Management India, Hospital Warming Solutions Providers India"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/64.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientionwarmingsystemmanufacture;